import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { arbManifest as complianceArbManifest } from '@amzn/product-widgets-compliance';
import arbManifest from '../../../build/translations/arbManifest';
export const DEFAULT_LOCALE = 'en-US';
export const localizationContextBuilder = new LocalizationContextBuilder().withDefaultLocale(DEFAULT_LOCALE);
// Merge compliance package translations into the host manifest.
// Prefix compliance translation paths so they resolve to /translations/compliance/
const mergedEndpointMap = {};
// Add host app endpoints first
Object.entries(arbManifest.endpointMap).forEach(([locale, bundles]) => {
    mergedEndpointMap[locale] = Object.assign({}, bundles);
});
// Merge compliance endpoints only for locales the host app already supports
Object.entries(complianceArbManifest.endpointMap).forEach(([locale, bundles]) => {
    if (mergedEndpointMap[locale]) {
        Object.entries(bundles).forEach(([bundleName, filePath]) => {
            mergedEndpointMap[locale][bundleName] = `compliance/${filePath}`;
        });
    }
});
const mbmOption = {
    arbManifest: Object.assign(Object.assign({}, arbManifest), { endpointMap: mergedEndpointMap }),
    defaultLocalizationContext: localizationContextBuilder.withLocale(DEFAULT_LOCALE).build(),
    urlPrefix: '/translations',
};
export default mbmOption;
